/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2021-present Rakuten Kobo Inc. (https://www.kobo.com)
 *
 * Utility functions for the tolino theme
 */

export function createUtils(colors, variables) {

  return Object.freeze({

    /**
     * Uses the themes basic font size to calculate a rem value based
     * on the provided pixel value
     *
     * @param {number} pixel A pixel value to convert
     * @returns {number} The calculated rem value
     */
    convertPixelToREM: function(pixel) {
      return pixel / variables._BASIC_FONT_SIZE;
    },


    /**
     * Uses the themes basic font size to calculate a pixel value based
     * on the provided rem value.
     *
     * @param {number} rem A rem value to convert
     * @returns {number} The calculated pixel value
     */
    convertREMToPixel: function(rem) {
      return rem * variables._BASIC_FONT_SIZE;
    },

    /**
     * Uses the saved highlight color to calculate the correct color
     *
     * @param {string} color Color to be recalculated
     * @returns {string} The calculated color value
     */
    mapHighlightThemeColors: function(color) {
      switch (color) {
        case colors.highlightYellowDark:
        case colors.highlightYellowLight:
          return 'yellow';
        case colors.highlightBlueDark:
        case colors.highlightBlueLight:
          return 'blue';
        case colors.highlightGreenDark:
        case colors.highlightGreenLight:
          return 'green';
        case colors.highlightPinkDark:
        case colors.highlightPinkLight:
          return 'pink';
        default:
          return 'yellow';
      }
    },

    /**
     * Uses the saved highlight color to calculate the correct tooltip color for dark theme
     *
     * @param {string} color Color to be recalculated
     * @returns {string} The calculated color value
     */
    mapHighlightTooltipThemeColors: function(color) {
      switch (color) {
        case colors.highlightYellowDark:
          return colors.highlightYellowBgDark;
        case colors.highlightBlueDark:
          return colors.highlightBlueBgDark;
        case colors.highlightGreenDark:
          return colors.highlightGreenBgDark;
        case colors.highlightPinkDark:
          return colors.highlightPinkBgDark;
        default:
          return color;
      }
    }

  });

};
